package com.tovtalk.data.remote.dto

import kotlinx.serialization.Serializable

@Serializable
data class DocSlugsDto(
    val slugs: List<String> = emptyList()
)
